import React from 'react';

const Footer = () => {
  return (
    <footer>
      {/* Contenido del pie de página */}
      <p className='Footer'>©  D3sarrollo  2024</p>
    </footer>
  );
};

export default Footer;